import { render, staticRenderFns } from "./GeneralError.vue?vue&type=template&id=e2788cd2&scoped=true&"
import script from "./GeneralError.vue?vue&type=script&lang=js&"
export * from "./GeneralError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2788cd2",
  null
  
)

export default component.exports